import app from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBndmD5mvP066rVQb_1dBo1Ml5x3CgF6uY",
  authDomain: "covishield-8c42f.firebaseapp.com",
  projectId: "covishield-8c42f",
  storageBucket: "covishield-8c42f.appspot.com",
  messagingSenderId: "674119347962",
  appId: "1:674119347962:web:909e1f910181da0a45a343"
};

class Firebase {
  constructor() {
    app.initializeApp(firebaseConfig);
    this.db = app.firestore();
    this.storage = app.storage();
  }
}

export default Firebase;
